export type WaitlistPersona = 'volunteer' | 'organisation' | 'club-charity';

export type WaitlistFormFields = {
  persona: WaitlistPersona;
  name: string;
  email: string;
  mobileNumber: string;
  organisationName: string;
  roleTitle: string;
  location: string;
  teamSize: string;
  causeFocus: string;
};

/** Columns on public.waitlist only. Omits empty optional fields. */
export function buildWaitlistInsertRow(form: WaitlistFormFields): Record<string, string> {
  const row: Record<string, string> = {
    persona: form.persona,
    name: form.name.trim(),
    email: form.email.trim().toLowerCase(),
  };

  const mobile = form.mobileNumber.trim();
  if (mobile) row.mobile_number = mobile;

  if (form.persona !== 'volunteer') {
    const organisationName = form.organisationName.trim();
    if (organisationName) row.organisation_name = organisationName;
    const roleTitle = form.roleTitle.trim();
    if (roleTitle) row.role_title = roleTitle;
    const location = form.location.trim();
    if (location) row.location = location;
  }

  if (form.persona === 'club-charity') {
    const teamSize = form.teamSize.trim();
    if (teamSize) row.team_size = teamSize;
    const causeFocus = form.causeFocus.trim();
    if (causeFocus) row.cause_focus = causeFocus;
  }

  return row;
}

export function isWaitlistRowValid(row: Record<string, string>): boolean {
  const name = (row.name ?? '').trim();
  const email = (row.email ?? '').trim();
  return name.length > 0 && email.includes('@') && email.length > 3;
}
